import { createTheme, ThemeProvider as MuiThemeProvider } from "@mui/material";
import { ConfigProvider, theme as antdTheme } from "antd";
import { CSSProperties, ReactNode } from "react";

// Same values as :root in index.css; the dark overrides live on <html data-theme="dark">, so the scope re-declares them.
const LIGHT_VARS = {
  "--app-bg": "#f2f3f4",
  "--app-surface": "#ffffff",
  "--app-text": "#1f2937",
  "--app-text-muted": "#595959",
  "--app-border": "#d9d9d9",
  "--app-border-light": "#f0f0f0",
  "--app-sidebar": "#ba2156",
  colorScheme: "light",
} as CSSProperties;

const lightMuiTheme = createTheme({
  palette: { mode: "light" },
  typography: { fontFamily: "inherit" },
});

const lightAntdTheme = {
  inherit: false,
  algorithm: antdTheme.defaultAlgorithm,
  token: { colorTextDescription: "#595959" },
};

/** Keeps a subtree (login, forgot/reset password) in the light theme even when the app is in dark mode. */
const LightScope = ({ children }: { children: ReactNode }) => (
  <MuiThemeProvider theme={lightMuiTheme}>
    <ConfigProvider theme={lightAntdTheme}>
      <div data-theme="light" style={LIGHT_VARS}>
        {children}
      </div>
    </ConfigProvider>
  </MuiThemeProvider>
);

export default LightScope;
